<template>
  <v-container fluid color="white--text">
    <v-card elevation="5">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-card flat>
              <v-card-title>Verify Transaction</v-card-title>
              <v-card-text>
                <p>
                  After a successful charge, you need to verify that the payment was successful with SasaPay before giving value to your customer. For every transaction, you must supply a transaction ID Request Payment : To request payment you need to make a POST call to the following url
                </p>
              </v-card-text>
              <v-divider/>
              <v-card-text>
                EndPoints:<br/>
                <div class="secondary pa-5" style="color: #e7e3fc">
                  <strong>Sandbox</strong>
                  <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/transactions/verify/"}}</p>
                </div>
              </v-card-text>
              <v-card-text>
                Request Parameters <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>MerchantCode</code>  <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>TransactionCode</code>  <br/>
              </v-card-text>
              <v-divider/>
              <v-card-text>
                Expected Results:<br/>

                Sasa<span class="red--text">Pay</span> returns the status code & a detailed message
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="">
            <h3>Sample Request</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                v-model="code"
                @lang="changeLanguage"
                :wrap_code="false"
                :language_selector="true"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['php','PHP'],['java','Java'],['python', 'Python'],['go','Go'],['csharp','C#'],['javascript', 'Node Js']]"
            ></code-editor>
            <v-divider/>
            <h3>Sample Response</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                v-model="response"
                :wrap_code="false"
                :language_selector="true"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['json','JSON']]"
            ></code-editor>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

import {
  verifyTransactionRequest,
  verifyTransactionResponse
} from "../../../../../shared/snippets/c2b/processPayment";

export default {
  name: "Authentications",
  // components: { VueStylelintEditor },
  data: () =>({
    selectedLanguage:"",
    code:"",
    response:"",
  }),
  mounted() {
    this.importVerificationSnippets('php')//
    this.importResponse()
  },
  methods:{
    importVerificationSnippets(lang){
      this.code=verifyTransactionRequest(lang)
    },
    importResponse(){
      this.response=verifyTransactionResponse()
    },
    changeLanguage(val){
      this.importVerificationSnippets(val)
    }
  }
}
</script>

<style scoped>

</style>